import React from 'react';
import { RoutePath } from './paths';
import { IndexPage } from '../pages/index';
import { EmploymentPage } from '../pages/employment/index';
import { ApplicationSubmittedPage } from '../pages/employment/application-submitted';
import { JobDetailPage } from '../templates/job';
import { WorksPage } from '../pages/works';
import { ServicesPage } from '../pages/services';
import { ProductsPage } from '../pages/products';
import { AutonomousVehiclePage } from '../pages/autonomous-vehicle';
import { CompanyPage } from '../pages/company-info';
import { LocationsPage } from '../pages/locations';
import { PrivacyPolicyPage } from '../pages/privacy-policy';
import { ThanksPage } from '../pages/thanks';
import { ShareTransferArticle } from '../articles/202004300900_share_transfer';
import { WebsiteRenewalArticle } from '../articles/20200314090000_new';
import { ExceloutArticle } from '../articles/20200314100000_excelout';
import { NotFoundPage } from '../pages/404';
import { TimehuntPrivacyPolicyPage } from '../pages/products/timehunt_privacy_policy';


export const routeElements: Record<RoutePath, React.ReactNode> = {
  '/': <IndexPage />,
  '/employment': <EmploymentPage />,
  '/employment/application-submitted': <ApplicationSubmittedPage />,
  '/jobs/:slug': <JobDetailPage />,
  '/works': <WorksPage />,
  '/services': <ServicesPage />,
  '/products': <ProductsPage />,
  '/autonomous-vehicle': <AutonomousVehiclePage />,
  '/company-info': <CompanyPage />,
  '/locations': <LocationsPage />,
  '/privacy-policy': <PrivacyPolicyPage />,
  '/products/timehunt_privacy_policy': <TimehuntPrivacyPolicyPage />,
  '/thanks': <ThanksPage />,
  '/articles/202004300900_share_transfer': <ShareTransferArticle />,
  '/articles/20200314090000_new': <WebsiteRenewalArticle />,
  '/articles/20200314100000_excelout': <ExceloutArticle />,
  '*': <NotFoundPage />,
} satisfies Record<RoutePath, React.ReactNode>;